import { render, staticRenderFns } from "./PlayerSearchItem.vue?vue&type=template&id=5ff6b2cc&scoped=true"
import script from "./PlayerSearchItem.vue?vue&type=script&lang=js"
export * from "./PlayerSearchItem.vue?vue&type=script&lang=js"
import "./PlayerSearchItem.vue?vue&type=style&index=0&id=5ff6b2cc&prod&lang=scss&scoped=true"
/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff6b2cc",
  null
  
)

export default component.exports